// File: PrivacyPolicy.jsx
import React, { useEffect } from "react";
import './privacy.css';
import Footer from "../pages/Footer";

export default function PrivacyPolicy() {
  // Scroll to exact top of section, accounting for sticky header
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const navbarHeight = document.querySelector(".navbar")?.offsetHeight || 0;
      const y = el.getBoundingClientRect().top + window.pageYOffset - navbarHeight - 10; 
      // -10 is optional small padding

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };
  return (
    <div className="privacy-container">
      {/* Page Title */}
      <h1 className="privacy-title">Privacy Policy</h1>
      <p className="last-updated">Last Updated: September 8, 2025</p>

      {/* Table of Contents */}
      <nav className="privacy-toc">
        <ul>
          <li><button onClick={() => scrollToSection("intro")}>Introduction</button></li>
          <li><button onClick={() => scrollToSection("data-collected")}>Data We Collect</button></li>
          <li><button onClick={() => scrollToSection("use-of-data")}>How We Use Your Data</button></li>
          <li><button onClick={() => scrollToSection("cookies")}>Cookies</button></li>
          <li><button onClick={() => scrollToSection("sharing")}>Data Sharing</button></li>
          <li><button onClick={() => scrollToSection("security")}>Data Security</button></li>
          <li><button onClick={() => scrollToSection("rights")}>Your Rights</button></li>
          <li><button onClick={() => scrollToSection("children")}>Children's Privacy</button></li>
          <li><button onClick={() => scrollToSection("contact")}>Contact Us</button></li>
        </ul>
      </nav>

      {/* Sections */}
      <section id="intro">
        <h2>Introduction</h2>
        <p>
          PrepX Pathshala (“we”, “our”, “us”) values your privacy. 
          This Privacy Policy explains how we collect, use, store, and protect your personal information 
          when you use our website, learning resources, and online services.
        </p>
      </section>

      <section id="data-collected">
        <h2>Data We Collect</h2>
        <p>
          We may collect information you provide directly, such as name, email, and contact number 
          when you sign up for our courses, contact us, or participate in discussions.
        </p>
        <p>
          We also collect usage data such as pages visited, session duration, and browser type 
          to improve user experience and optimize content.
        </p>
      </section>

      <section id="use-of-data">
        <h2>How We Use Your Data</h2>
        <ul>
          <li>Provide and manage your access to our educational resources</li>
          <li>Improve our website, lectures, and user experience</li>
          <li>Send you course updates, notifications, and important announcements</li>
          <li>Analyze website performance and engagement</li>
        </ul>
      </section>

      <section id="cookies">
        <h2>Cookies</h2>
        <p>
          We use cookies to store user preferences, track analytics, and enhance 
          your browsing experience. You can disable cookies in your browser settings, 
          but some features may not work properly.
        </p>
      </section>

      <section id="sharing">
        <h2>Data Sharing</h2>
        <p>
          We do not sell or trade your personal information. 
          We may share your data with trusted service providers (e.g., hosting, analytics) 
          who are bound by confidentiality agreements.
        </p>
      </section>

      <section id="security">
        <h2>Data Security</h2>
        <p>
          We implement industry-standard security measures (encryption, firewalls) 
          to protect your data. However, no method of transmission over the internet is 100% secure.
        </p>
      </section>

      <section id="rights">
        <h2>Your Rights</h2>
        <p>
          You may request access, correction, or deletion of your personal data 
          at any time by contacting us. If required by law (e.g., GDPR/CCPA), 
          you may also request to restrict processing or object to data use.
        </p>
      </section>

      <section id="children">
        <h2>Children's Privacy</h2>
        <p>
          Our services are intended for students but not for children under 13 
          without parental consent. We do not knowingly collect information from minors.
        </p>
      </section>

      <section id="contact">
        <h2>Contact Us</h2>
        <p>
          For questions about this Privacy Policy, please contact: <br />
          Email: 📧 prepxpathshala@gmail.com <br />
          Phone: 📞 +817083110880 <br />
          Website/Link: 🔗 https://prepxpathshala.live/contact-us <br />
          📍 Address: PrepX Pathshala, Online Learning Platform
        </p>
      </section>

      {/* Footer */}
       <Footer />
    </div>
  );
}